var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.item.length
    ? _c("section", { staticClass: "module actors" }, [
        _c("h3", [_vm._v("演职人员")]),
        _vm._v(" "),
        _c("div", { staticClass: "actors-wrap" }, [
          _c(
            "ul",
            { staticClass: "actors-list" },
            [
              _vm._l(_vm.item, function (i, index) {
                return [
                  _c("li", { key: index }, [
                    _c(
                      "a",
                      {
                        attrs: {
                          href:
                            "/star?query=" +
                            encodeURIComponent(i.star) +
                            "&spver=" +
                            _vm.spver,
                          uigs: "actor_" + encodeURIComponent(i.star),
                        },
                      },
                      [
                        _c("div", { staticClass: "actors-item-img" }, [
                          _c("img", {
                            directives: [
                              {
                                name: "lazy",
                                rawName: "v-lazy",
                                value: i.image,
                                expression: "i.image",
                              },
                            ],
                          }),
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "actors-item-info" },
                          [
                            _c("p", { staticClass: "name" }, [
                              _vm._v(_vm._s(i.star)),
                            ]),
                            _vm._v(" "),
                            i.role !== ""
                              ? [
                                  i.cate && i.cate === "shengyou"
                                    ? _c("p", { staticClass: "role" }, [
                                        _vm._v("配 " + _vm._s(i.role)),
                                      ])
                                    : _c("p", { staticClass: "role" }, [
                                        _vm._v("饰 " + _vm._s(i.role)),
                                      ]),
                                ]
                              : [
                                  i.cate && i.cate !== ""
                                    ? _c("p", { staticClass: "role" }, [
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(_vm.cate(i.cate)) +
                                            "\n                "
                                        ),
                                      ])
                                    : _vm._e(),
                                ],
                          ],
                          2
                        ),
                      ]
                    ),
                  ]),
                ]
              }),
            ],
            2
          ),
        ]),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }